import { useI18n } from '../../../../i18n/i18n'
import './feature-band.scss'

export function FeatureBand() {
  const { t } = useI18n()
  const pontos = t('feature.pontos') as string[]
  return (
    <section className="feature-band">
      <div className="feature-band__media">
        <img
          src="https://images.unsplash.com/photo-1573497491208-6b1acb260507?auto=format&fit=crop&w=900&q=70"
          alt="Reunião de consultoria com o cliente"
          loading="lazy"
        />
      </div>

      <div className="feature-band__text">
        <span className="eyebrow">{t('feature.eyebrow')}</span>
        <h2 className="section-heading">{t('feature.title')}</h2>
        <p>{t('feature.text')}</p>
        <ul>
          {pontos.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}
